import { Box, Grid } from '@mui/material';
import { Grid25, Grid50 } from '/b2b/common/components/Reporting/Grid';
import { PRODUCT_ORDER, REPORT_SPAN } from '../constants';
import React, { Fragment, useCallback, useMemo } from 'react';

import Greeting from './components/Greeting';
import { LoadingCoordinator } from '/b2b/common/hoc/withAsyncData';
import PropTypes from 'prop-types';
import TodoList from './components/TodoList';
import makeStyles from '@mui/styles/makeStyles';
import styles from './Dashboard.styles';

const useStyles = makeStyles(styles);

const Dashboard = props => {
    const classes = useStyles(props);

    const { allowedReports = {} } = props;

    const reports = useMemo(
        () =>
            Object.entries(allowedReports)
                .filter(([_, { default: isDefault }]) => isDefault)
                .sort(
                    ([_, { product: productA }], [__, { product: productB }]) =>
                        PRODUCT_ORDER.indexOf(productA) - PRODUCT_ORDER.indexOf(productB)
                ),
        [allowedReports]
    );

    const getGridItem = useCallback(
        (index, layout = {}) => {
            const isLastReport = index === reports.length - 1;
            const isOddCount = reports.length % 2 === 1;

            const isFullWidth =
                layout.span === REPORT_SPAN.FULL ||
                (layout.span !== REPORT_SPAN.HALF &&
                    (reports.length === 1 || (isLastReport && isOddCount)));

            const gridProps = { xs: 12, lg: isFullWidth ? 12 : 6 };

            if (layout.autoHeight) {
                return { Component: Grid, gridProps };
            }

            return {
                Component: reports.length === 1 ? Grid50 : Grid25,
                gridProps,
            };
        },
        [reports.length]
    );

    return (
        <LoadingCoordinator>
            <Box className={classes.root} sx={{ minHeight: '100vh' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Greeting />
                    </Grid>
                    <Fragment>
                        <Grid item order={{ xs: 0, xl: 30 }} xs={12} xl={5}>
                            <TodoList componentId="todoList" />
                        </Grid>
                        <Grid item order={{ xs: 10, xl: 20 }} xs={12} xl={7}>
                            <Grid container spacing={2}>
                                {Object.keys(allowedReports).length > 0 &&
                                    reports.map(
                                        (
                                            [
                                                report,
                                                { Component: ReportComponent, filters, layout },
                                            ],
                                            index
                                        ) => {
                                            const { Component: GridComponent, gridProps = {} } =
                                                getGridItem(index, layout);
                                            return (
                                                <GridComponent key={report} item {...gridProps}>
                                                    <ReportComponent
                                                        componentId={report}
                                                        filters={filters}
                                                    />
                                                </GridComponent>
                                            );
                                        }
                                    )}
                            </Grid>
                        </Grid>
                    </Fragment>
                </Grid>
            </Box>
        </LoadingCoordinator>
    );
};

Dashboard.propTypes = {
    allowedReports: PropTypes.object.isRequired,
};

export default Dashboard;
